import React, { useEffect, useMemo, useState } from "react";
import useApi from "../../CustomHooks/useApi";
import LoadingOverlay from "../../../LoadingOverlay";
import { viewsAccessAPI } from "../../../api/apiClient";
import ViewsMode from "./ViewsMode";
import "../../../css/Views/ViewAccessView.css";

const Mode = {
  ByView: "byView",
  ByUser: "byUser",
};

const ViewAccess = () => {
  const { callApi, isLoading } = useApi();

  const [snapshot, setSnapshot] = useState(null);
  const [mode, setMode] = useState(Mode.ByView);
  const [search, setSearch] = useState("");

  useEffect(() => {
    callApi(
      () => viewsAccessAPI.getAllAccesses(),
      (data) => setSnapshot(data)
    );
  }, []);

  const stats = useMemo(() => {
    return {
      viewsCount: snapshot?.views?.length || 0,
      adminsCount: snapshot?.admins?.length || 0,
      sysAdminsCount: snapshot?.systemAdmins?.length || 0,
    };
  }, [snapshot]);

  if (!snapshot && isLoading) return <LoadingOverlay text="Ładowanie uprawnień..." />;
  if (!snapshot) return <div className="va-container">Brak danych....</div>;

  return (
    <div className="va-container">
      {isLoading ? <LoadingOverlay text="Ładowanie..." /> : null}

    <div className="va-header-wrapper">
    <div className="va-bank-header-centered">
        <span>Uprawnienia &nbsp; </span>
        <i
        className="fa fa-sync va-refresh-icon"
        onClick={() =>
            callApi(
            () => viewsAccessAPI.getAllAccesses(),
            (data) => setSnapshot(data)
            )
        }
        />
    </div>

    <div className="va-toolbar">
        <input
        className="va-search"
        placeholder="Szukaj (widok, rola, user, email)..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        />
    </div>
    </div>




<div className="va-admins">
  <div className="va-admins-grid">
    <div className="va-admin-card">
      <div className="va-admin-card-header">
        <div className="va-admin-card-title">Administratorzy systemowi</div>
        <div className="va-admin-count">{(snapshot.systemAdmins || []).length}</div>
      </div>

<div className="va-badges va-admin-badges">
  {(snapshot.systemAdmins || []).length ? (
    (snapshot.systemAdmins || []).map((u) => (
      <span key={u.guid} className="va-badge va-badge-sysadmin">
        {u.preferredName}
        {u.email ? <span className="va-muted">({u.email})</span> : null}
      </span>
    ))
  ) : (
    <span className="va-muted">Brak</span>
  )}
</div>

    </div>

    <div className="va-admin-card">
      <div className="va-admin-card-header">
        <div className="va-admin-card-title">Administratorzy</div>
        <div className="va-admin-count">{(snapshot.admins || []).length}</div>
      </div>

    <div className="va-badges va-admin-badges">
  {(snapshot.admins || []).length ? (
    (snapshot.admins || []).map((u) => (
      <span key={u.guid} className="va-badge va-badge-admin">
        {u.preferredName}
        {u.email ? <span className="va-muted">({u.email})</span> : null}
      </span>
    ))
  ) : (
    <span className="va-muted">Brak</span>
  )}
</div>

    </div>
  </div>
</div>

        <ViewsMode views={snapshot.views || []} search={search} />

    </div>
  );
};

export default ViewAccess;
